module.exports = __webpack_public_path__ + "static/media/logo.650d9f7a.png";